import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

import { defaultState } from "../configureStore";

export default handleActions(
  {
    PROPOSAL_ACCEPT: {
      FULFILLED: ({ proposal }) => ({
        proposal: { ...proposal, accepted: true },
      }),
    },
    PROPOSAL_GET: {
      PENDING: () => ({
        proposal: defaultState.proposal,
      }),
      FULFILLED: (state, action) => ({
        proposal: action.payload.proposal,
      }),
    },
    PROPOSAL_CREATE: {
      FULFILLED: (state, action) => ({
        proposals: [action.payload.proposal, ...state.proposals],
      }),
    },

    PROPOSAL_DELETE: {
      FULFILLED: (state, action) => ({
        proposals: removeById(state.proposals, action.meta.proposalID),
      }),
    },

    PROPOSAL_SAVE: {
      FULFILLED: (state, action) => ({
        proposals: updateById(state.proposals, action.payload.proposal),
      }),
    },

    PROPOSALS_GET: {
      PENDING: () => ({
        proposals: [],
      }),
      FULFILLED: (state, action) => ({
        proposals: action.payload.proposals,
      }),
    },
  },
  {},
  { namespace: "_" }
);
